import { render, staticRenderFns } from "./bindPage.vue?vue&type=template&id=f03285fe&scoped=true&"
import script from "./bindPage.vue?vue&type=script&lang=js&"
export * from "./bindPage.vue?vue&type=script&lang=js&"
import style0 from "./bindPage.vue?vue&type=style&index=0&id=f03285fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03285fe",
  null
  
)

export default component.exports